(function () {
  // 🚀 1. Wyłącz animacje jeśli użytkownik ma reduce-motion
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) {
    document.getElementById('view-transition-render-blocker')?.remove();
    return; // STOP – nie ładuj reszty skryptu, oszczędzamy CPU
  }

  // 🚀 2. Funkcja idle dla odciążenia wątku głównego
  const idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 1); };

  // 🔍 Mały helper
  const hasViewTransition = (event) =>
    "viewTransition" in event && event.viewTransition instanceof ViewTransition;

  // 🚀 3. Obsługa zmiany strony
  window.addEventListener("pageswap", (event) => {
    if (!hasViewTransition(event)) return;

    const vt = event.viewTransition;

    // ⛔ Natychmiast anuluj transition jeśli user zaczyna interakcję
    ["pointerdown", "keydown"].forEach((ev) => {
      document.addEventListener(
        ev,
        () => vt.skipTransition(),
        { once: true, passive: true }
      );
    });

    // 🧹 Czyścimy stare typy
    document
      .querySelectorAll("[data-view-transition-type]:not([data-view-transition-triggered])")
      .forEach((el) => el.removeAttribute("data-view-transition-type"));

    // 📌 Pobieramy wybrany typ
    const trigger = document.querySelector("[data-view-transition-triggered]");
    const type = trigger?.getAttribute("data-view-transition-type");

    vt.types.clear();
    if (type) {
      vt.types.add(type);
      sessionStorage.setItem("vt-type", type);
    } else {
      vt.types.add("page-navigation");
      sessionStorage.removeItem("vt-type");
    }
  });

  // 🚀 4. Obsługa reveal (wejścia na stronę)
  window.addEventListener("pagereveal", async (event) => {
    if (!hasViewTransition(event)) return;

    const vt = event.viewTransition;
    const saved = sessionStorage.getItem("vt-type");

    vt.types.clear();

    if (saved) {
      vt.types.add(saved);

      await vt.finished;

      vt.types.clear();
      vt.types.add("page-navigation");

      idle(() => {
        sessionStorage.removeItem("vt-type");
        document
          .querySelectorAll("[data-view-transition-type]")
          .forEach((el) => el.removeAttribute("data-view-transition-type"));
      });
    } else {
      vt.types.add("page-navigation");
    }
  });
})();
